module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "agent-apply-dialog",
    attrs: {
      "close-on-click-modal": false,
      "title": _vm.title,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "经销商类型："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.Industry_Name) + "\n            ")]), _vm._v(" "), _c('h4', [_vm._v("公司基本信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.baseInfo.CustomerName) + "\n            ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属招商经理："
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.baseInfo.LeasingManagerName) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属业务经理："
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.baseInfo.BusEmployeeName) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseInfo.SocialCreditCode !== ''),
      expression: "baseInfo.SocialCreditCode!==''"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "统一社会信用代码：",
      "label-width": "140px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.baseInfo.SocialCreditCode) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseInfo.Corporation !== ''),
      expression: "baseInfo.Corporation!==''"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司法定代表人：",
      "label-width": "130px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.baseInfo.Corporation) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人身份证："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.baseInfo.Corporation_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "营业执照："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.baseInfo.Company_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司地址："
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.baseInfo.ProvName) + "-- " + _vm._s(_vm.baseInfo.CityName) + "-- " + _vm._s(_vm.baseInfo.AreaName) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.baseInfo.DataTypeName) + "\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Companys.length > 0),
      expression: "Companys.length>0"
    }],
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, _vm._l((_vm.Companys), function(item) {
    return _c('el-collapse-item', [_c('template', {
      slot: "title"
    }, [_vm._v("\n                            " + _vm._s(item.Customer) + "（" + _vm._s(item.StartTime) + "-" + _vm._s(item.EndTime) + "）\n                            "), _c('i', {
      staticClass: "header-icon el-icon-info"
    })]), _vm._v(" "), _c('el-form', {
      staticClass: "demo-table-expand",
      attrs: {
        "label-position": "left",
        "inline": ""
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "公司:"
      }
    }, [_c('span', [_vm._v(_vm._s(item.Customer))])]), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "所属招商经理:"
      }
    }, [_c('span', [_vm._v(_vm._s(item.LeasingManagerName))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "所属业务经理:"
      }
    }, [_c('span', [_vm._v(_vm._s(item.BusEmployeeName))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "统一社会信用代码:"
      }
    }, [_c('span', [_vm._v(_vm._s(item.SocialCreditCode))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "公司法定人代表:"
      }
    }, [_c('span', [_vm._v(_vm._s(item.Corporation))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      staticClass: "viewImgPos",
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "法人身份证:"
      }
    }, [_c('ul', {
      staticClass: "img-list"
    }, _vm._l((item.Corporation_Drawing), function(img, index) {
      return _c('li', {
        staticClass: "img-box"
      }, [_c('img', {
        attrs: {
          "src": img.Url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "img-mask"
      }, [_c('i', {
        staticClass: "el-icon-view",
        on: {
          "click": function($event) {
            _vm.showImgView(img)
          }
        }
      })])])
    }))])], 1), _vm._v(" "), _c('el-col', {
      staticClass: "viewImgPos",
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "营业执照:"
      }
    }, [_c('ul', {
      staticClass: "img-list"
    }, _vm._l((item.Company_Drawing), function(img, index) {
      return _c('li', {
        staticClass: "img-box"
      }, [_c('img', {
        attrs: {
          "src": img.Url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "img-mask"
      }, [_c('i', {
        staticClass: "el-icon-view",
        on: {
          "click": function($event) {
            _vm.showImgView(img)
          }
        }
      })])])
    }))])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "公司地址:"
      }
    }, [_c('span', [_vm._v(_vm._s(item.ProvName) + _vm._s(item.CityName) + _vm._s(item.AreaName))])])], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "数据类型:"
      }
    }, [_c('span', [_vm._v(_vm._s(item.DataTypeName))])])], 1)], 1)], 1)], 2)
  }))], 1), _vm._v(" "), _c('h4', [_vm._v("联系人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主联系人："
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.contact.C_Name) + "\n                    ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人电话：",
      "label-width": "100px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.contact.C_Tel) + "\n                    ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人地址："
    }
  }, [(_vm.contact.AreaName !== '') ? _c('span', [_vm._v(" " + _vm._s(_vm.contact.ProvName) + "-" + _vm._s(_vm.contact.CityName) + "-" + _vm._s(_vm.contact.AreaName))]) : _c('span', [_vm._v(" " + _vm._s(_vm.contact.ProvName) + "-" + _vm._s(_vm.contact.CityName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.contact.Address) + "\n            ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人身份证："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.contact.C_IDNumber_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5c55092d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/CRMFormatAgent/components/viewDialog/index.vue
// module id = 1492
// module chunks = 1